import { PropsWithChildren } from "react";
import { Swiper } from "swiper/types";

export interface ModalProps extends PropsWithChildren {
    wrapperId?: string;
    isOpen: boolean;
    handleClose?: () => void;
    type: ModalTypes;
    propsForModalType: ModalWithTitleAndCloseProps | ModalWithSliderProps;
    enableFocusTrap?: boolean;
    enableScrollLock?: boolean;
}

export interface ModalWithTitleAndCloseProps extends PropsWithChildren {
    title: string;
    backgroundColor?: string;
    handleClose?: () => void;
}

export interface ModalWithSliderProps extends PropsWithChildren {
    onSlideChange?: (swiper: Swiper) => void;
    initialSlide?: number;
    handleClose?: () => void;
    onSwiper?: (swiper: Swiper) => void;
}

export enum ModalTypes {
    MODAL_WITH_TITLE_AND_CLOSE = "modal_with_title_and_close",
    MODAL_WITH_SLIDER = "modal_with_slider",
}
